import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowDownLarge, ArrowUpLarge, CircleFilled } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

const styles = stylex.create({
  container: {
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
  },
  iconWrapper: {
    position: 'relative',
  },
  notificationDot: {
    position: 'absolute',
    right: -4,
    top: -10,
  },
})

interface SidebarParentItemProps {
  isOpen: boolean
  active: boolean
  value: string
  onClick?: () => void
  isNotifying?: boolean
}

export const SidebarParentItem = ({ value, isOpen, active, onClick, isNotifying }: SidebarParentItemProps) => {
  const color = active ? colors.grey900 : colors.grey600
  return (
    <HStack p={4} rootStyle={styles.container} onClick={onClick}>
      <Text variant="subtitle" color={color}>{value}</Text>
      <Box rootStyle={styles.iconWrapper}>
        {isOpen ? <ArrowUpLarge color={colors.grey500} fontSize={20} /> : <ArrowDownLarge color={colors.grey500} fontSize={20} />}
        {isNotifying && (
          <Box rootStyle={styles.notificationDot}>
            <CircleFilled color={colors.red500} fontSize={8} />
          </Box>
        )}
      </Box>
    </HStack>
  )
}
